import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import store from "../../../redux/store";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import {
  ApUpdatePlan_Url,
  ApDeletePlan_Url,
  ApCreatePlan_Url,
  ApUpdateUseCase_Url,
  ApDeleteUseCase_Url,
  ApGetUseCase_Url,
  ApBusinessTypeList_Url,
  ApDomainList_Url,
  ApUseCaseList_Url,
} from "../../../provider/ServiceUrl";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import PtsButton from "../../givBee/buttons/PtsButton";
import { withRouter } from "../../../withRouter";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import CancelIconButton from "../../givBee/buttons/CancelIconButton";
import { ValidatorForm } from "react-material-ui-form-validator";
import SaveButton from "../../givBee/buttons/SaveButton";
import Utils from "../../../provider/Utils";
import { Col } from "reactstrap";
import Plan from "./Plan";
import { SUBSCRIPTION_TYPES } from "../../../provider/Enums";
import { Autocomplete } from "@mui/material";
import PreviewPlans from "./PreviewPlans";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import TextField from "@material-ui/core/TextField";
import IconButton from "@mui/material/IconButton";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";

class PlanList extends Component {
  title = "Plan List";
  breadCrumb = [
    { pageid: "/billingPlans", uiname: "Business Type List" },
    { pageid: "/useCaseList", uiname: "Use Cases" },
    { pageid: "", uiname: "Plan List" },
  ];
  header = store.getState().adminHeader.adminHeader;

  constructor(props) {
    super(props);

    let action = props.state?.action;
    let propBusinessType = null;
    let propBusinessDomain = null;
    let propBusinessUseCase = null;

    if (props.state) {
      propBusinessType = props.state?.businessType;
      propBusinessDomain = props.state?.businessDomain;
      propBusinessUseCase = props.state?.businessUseCase;
    }

    this.state = {
      planName: "",
      action: action,
      selectedTab: 0,
      render: false,
      getCreatePermission: false,
      planId: 0,
      planList: [],
      tabPlanList: [],
      useCaseName: propBusinessUseCase?.name,
      editingIndex: null,
      openDialogBox: false,
      index: null,
      selectedSubscriptionTab: SUBSCRIPTION_TYPES.payMonthly,
      editedPlan: {
        planItems: [],
      },
      businessDomain: propBusinessDomain,
      businessType: propBusinessType,
      businessUseCase: propBusinessUseCase,
      businessDomainList: [],
      businessTypeList: [],
      businessUseCaseList: [],
      selectBusinessDomain: null,
      selectBusinessType: null,
      selectBusinessUsecase: null,
      selectedPlanId: "",
      movePlanDetails: false,
      openAccountPlan: false,
      initialPage: 0,
      pageSize: 10,
    };
    this.getPlanListForUseCase(this.state.businessUseCase);
  }
  // componentDidMount() {
  //   this.getPlanListForUseCase(this.state.businessUseCase);
  // }

  getPlanListForUseCase(businessUseCase) {
    const postObject1 = {
      header: this.header,
      businessUseCase: {
        id: businessUseCase?.id,
      },
    };
    AdminFetchServerData.callPostService(ApGetUseCase_Url, postObject1).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let businessUseCaseDetails = output.data.businessUseCase;
          let planTypes = businessUseCaseDetails?.planTypes?.sort(
            (a, b) => a.displaySequence - b.displaySequence
          );
          let planList = businessUseCaseDetails?.plans;
          planList.sort((a, b) => b.displaysequence - a.displaysequence);
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          planList.forEach((plan) => {
            plan.planItems.sort(
              (a, b) => a.displaysequence - b.displaysequence
            );
          });

          let getCreatePermission = getPermission[1];

          for (let i = 0; i < planList.length; i++) {
            let ref = React.createRef();
            this.planRefList.push(ref);
            planList[i].action = "view";
            planList[i].operation = "update";
            let planItems = planList[i].planItems;
            for (let i = 0; i < planItems.length; i++) {
              // let ref = React.createRef();
              // this.appointmentReminderRefList.push(ref);
              /*Set Default Operation as Update */
              planItems[i].operation = "UPDATE";
            }
          }
          // if (businessUseCaseDetails?.subscriptionTypes.length === 0) {
          //   businessUseCaseDetails?.subscriptionTypes.push(
          //     SUBSCRIPTION_TYPES.payMonthly
          //   );
          // }

          for (let i = 0; i < planList.length; i++) {
            planList[i].action = "view";
          }

          this.setState({
            render: true,
            action: "view",
            planList: planList,
            tabPlanList: planTypes,
            getCreatePermission: getCreatePermission,
          });
        }
      }
    );
  }

  updateBusinessUseCaseNameToBackend() {
    const postObject = {
      header: this.header,
      businessUseCase: {
        name: this.state.useCaseName,
        id: this.state.businessUseCase.id,
        businessType: {
          id: this.state.businessType?.id,
          businessUsecaseList: [],
          businessDomain: {
            id: this.state.businessDomain?.id,
          },
        },
        plans: [],
      },
    };
    AdminFetchServerData.callPostService(ApUpdateUseCase_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let businessUseCase = output.data.businessUseCase;
          this.setState({
            action: "view",
            businessUseCase: businessUseCase,
          });
        }
      }
    );
  }

  deleteUseCaseDetails() {
    const postObject = {
      header: this.header,
      businessUseCase: {
        id: this.state.businessUseCase.id,
      },
    };

    AdminFetchServerData.callPostService(ApDeleteUseCase_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate("/useCaseList", {
            state: {
              action: "view",
              businessDomain: this.state.businessDomain,
              businessType: this.state.businessType,
              businessUseCase: this.state.businessUseCase,
            },
          });
        }
      })
      .catch((error) => { });
  }

  addPlanData = (planType) => {
    let plans = this.state.planList;
    const newPlan = {
      id: null, // or a temporary id, depending on your requirements
      action: "create",
      operation: "add",
      displaysequence: "",
      validityDays: "",
      smsCredits: "",
      overagesRate: "",
      overagesBlocksize: "",
      planType: planType,
      name: "",
      currency: "",
      price: "",
      colorPrimary: "#26b9f2",
      colorSecondary: "#9bdef9",
      status: { status: "Active" },
      planItems: [
        {
          id: "",
          operation: "ADD",
          displaysequence: 1,
          name: "",
          isFontBold: false,
          isFontItalic: false,
          isFontSize: false,
        },
      ], // Initial empty plan item
    };
    plans.push(newPlan);
    this.setState({
      planList: plans,
    });
  };
  addDuplicatePlan = (plan) => {
    let plans = this.state.planList;
    for (let i = 0; i < plan.planItems.length; i++) {
      // const element = plan.planItems[i];
      plan.planItems[i].id = "";
      plan.planItems[i].operation = "ADD";
    }
    const newPlan = {
      id: null, // or a temporary id, depending on your requirements
      action: "duplicate",
      operation: "add",
      displaysequence: "",
      planType: plan.selectedPlanType,
      validityDays: plan.validityDays,
      smsCredits: plan.smsCredits,
      overagesRate: plan.overagesRate,
      overagesBlocksize: plan.overagesBlocksize,
      subscriptionType: plan.subscriptionType,
      name: "",
      currency: plan.currency,
      price: plan.price,
      colorPrimary: plan.colorPrimary,
      colorSecondary: plan.colorSecondary,
      status: {
        status: plan.planStatus,
        id: plan.planStatus === "Active" ? 1 : 2,
      },
      planItems: plan.planItems, // Initial empty plan item
    };
    plans.push(newPlan);
    this.setState({
      planList: plans,
    });
  };

  addPlanInBackend(plan) {
    let displaysequenceList = [];
    for (let i = 0; i < plan.planItems.length; i++) {
      const displaysequence = plan.planItems[i].displaysequence;
      displaysequenceList.push(displaysequence);
    }
    let isDuplicate =
      new Set(displaysequenceList).size !== displaysequenceList.length;
    if (isDuplicate) {
      PtsAlert.error(
        "Display sequence is already in use. Please enter a unique value."
      );
      return;
    }
    const postObject = {
      header: this.header,
      plan: {
        name: plan.name,
        price: plan.price,
        planType: plan.selectedPlanType,
        status: {
          status: plan.planStatus,
          id: plan.planStatus === "Active" ? 1 : 2,
        },
        // subscriptionType: plan.subscriptionType,
        displaysequence: plan.displaysequence,
        validityDays: plan.validityDays,
        smsCredits: plan.smsCredits,
        overagesRate: plan.overagesRate,
        overagesBlocksize: plan.overagesBlocksize,
        colorPrimary: plan.colorPrimary,
        colorSecondary: plan.colorSecondary,
        planItems: plan.planItems,
      },
      businessUseCase: {
        id: this.state.businessUseCase.id,
      },
    };
    AdminFetchServerData.callPostService(ApCreatePlan_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          this.getPlanListForUseCase(this.state.businessUseCase);
        }
      })
      .catch((error) => { });
  }

  updatePlanInBackend(plan) {
    const postObject = {
      header: this.header,
      plan: {
        id: plan.id,
        name: plan.name,
        price: plan.price,
        // currency: plan.currency,
        planType: plan.selectedPlanType,
        // subscriptionType: plan.subscriptionType,
        displaysequence: plan.displaysequence,
        validityDays: plan.validityDays,
        smsCredits: plan.smsCredits,
        overagesRate: plan.overagesRate,
        overagesBlocksize: plan.overagesBlocksize,
        colorPrimary: plan.colorPrimary,
        colorSecondary: plan.colorSecondary,
        planItems: plan.planItems,
        status: {
          status: plan.planStatus,
          id: plan.planStatus === "Active" ? 1 : 2,
        },
      },
      businessUseCase: {
        id: this.state.businessUseCase.id,
      },
    };
    AdminFetchServerData.callPostService(ApUpdatePlan_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          this.getPlanListForUseCase(this.state.businessUseCase);
        }
      })
      .catch((error) => { });
  }

  planRemove(item) {
    let items = [];
    if (item.operation && "update" === item.operation) {
      let index = item.index;

      for (let i = 0; i < this.state.planList.length; i++) {
        let item = this.state.planList[i];
        if (this.state.planList[i].operation === "update" && index === i) {
          item.operation = "delete";
        }

        items.push(item);
      }

      this.setState({ planList: items });
    }
    if (item.operation && "add" === item.operation) {
      /* Added Item Deleted, Remove from list */
      let index = item.index;
      for (let i = 0; i < this.state.planList.length; i++) {
        if (this.state.planList[i].operation === "add" && index === i) {
          this.planRefList.splice(i, 1);
        } else {
          items.push(this.state.planList[i]);
        }
      }
      this.setState({ planList: items });
    }
  }

  deletePlan = (data) => {
    const postObject = {
      header: this.header,
      plan: {
        id: data.id,
      },
    };
    AdminFetchServerData.callPostService(ApDeletePlan_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          const updatedPlanList = this.state.planList.map((plan) =>
            plan.id === data.id ? { ...plan, operation: "delete" } : plan
          );

          this.setState({
            planList: updatedPlanList,
            openDialogBox: false,
          });
        }
      }
    );
  };

  editCancel() {
    this.setState({ action: "view" });
  }
  editUseCaseDetails() {
    this.setState({
      action: "edit",
      useCaseName: this.state.businessUseCase?.name,
    });
  }

  viewCancel() {
    this.props.navigate("/useCaseList", {
      state: {
        action: "view",
        businessDomain: this.state.businessDomain,
        businessType: this.state.businessType,
        businessUseCase: this.state.businessUseCase,
      },
    });
  }

  handleUseCaseEdit(e) {
    this.setState({ useCaseName: e.target.value });
  }

  setKey(tab) {
    this.setState({
      selectedTab: tab,
    });
  }
  toPreviewPlansDetails() {
    // let plansData = Object.assign(data, { messageId: this.state.messageId });
    if (this.previewPlansDialogueRef && this.previewPlansDialogueRef.current) {
      this.previewPlansDialogueRef.current.showPreviewPlanList(
        this.state.businessType,
        this.state.businessUseCase,
        this.state.tabPlanList,
        this.state.planList
      );
    }
  }

  handleMovePlanDetailsOpen(selectedPlanId) {
    this.setState({
      movePlanDetails: true,
      selectedPlanId: selectedPlanId,
    });
    this.getBusinessDomainList();
  }

  handleMovePlanDetailsClose() {
    this.setState({
      movePlanDetails: false,
      selectBusinessDomain: null,
      businessTypeList: [],
      businessUseCaseList: [],
      selectBusinessType: null,
      selectBusinessUsecase: null,
    });
  }

  moveSelectDestiniUsecase() {
    const postObject1 = {
      header: this.header,
      plan: { id: this.state.selectedPlanId },
      businessUseCase: {
        id: this.state.selectBusinessUsecase?.id,
      },
    };
    AdminFetchServerData.callPostService(
      "/planms/createInUsecase",
      postObject1
    ).then((output) => {
      if (output.status === "SUCCESS") {
        this.getPlanListForUseCase(this.state.selectBusinessUsecase);
        // this.props.navigate(`/planList`, {
        //   state: {
        //     action: "view",
        //     businessUseCase: this.state.businessUseCase,
        //     businessDomain: this.state.businessDomain,
        //     businessType: this.state.businessType,
        //   },
        // });
        this.setState({
          movePlanDetails: false,
          action: "view",
          businessUseCase: this.state.selectBusinessUsecase,
          useCaseName: this.state.selectBusinessUsecase?.name,
          businessDomain: this.state.selectBusinessDomain,
          businessType: this.state.selectBusinessType,
          selectBusinessDomain: null,
          selectBusinessType: null,
          selectBusinessUsecase: null,
          selectedPlanId: "",
        });
      }
    });
  }

  movePlanUnderUsecase() {
    return (
      <>
        <Dialog
          open={this.state.movePlanDetails}
          onClose={this.handleMovePlanDetailsClose.bind(this)}
          style={{ padding: "1em" }}
          maxWidth="xl"
          className="customerPlanDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Select the destination</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleMovePlanDetailsClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.moveSelectDestiniUsecase.bind(this)}
          >
            <DialogContent>
              <div className="col-md-12 pt-2">
                <div className="row justify-align-center">
                  <div className="col-sm-3">
                    <label
                      className="col-form-label fw-bold"
                      htmlFor="domain-name"
                      id="assetFormLabel"
                    >
                      Domain Name:
                    </label>
                  </div>
                  <div className="col-sm-9">
                    <Autocomplete
                      id="size-small-outlined"
                      size="small"
                      fullWidth
                      disableClearable
                      autoComplete="off"
                      ListboxProps={{
                        className: "custom-listbox",
                      }}
                      options={this.state.businessDomainList}
                      value={this.state.selectBusinessDomain}
                      getOptionLabel={(option) => option.name}
                      defaultValue={this.state.selectBusinessDomain}
                      onChange={(event, value) => {
                        this.handleBusinessDomainChange(value);
                      }}
                      inputprops={{
                        style: { textTransform: "capitalize" },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Domain Name"
                          variant="outlined"
                          size="small"
                          className="autoComplete"
                          style={{ background: "#fff" }}
                        />
                      )}
                    />
                  </div>
                </div>
                {this.state.businessTypeList.length > 0 && (
                  <div className="row mt-3 justify-align-center">
                    <div className="col-sm-3">
                      <label
                        className="col-form-label fw-bold"
                        htmlFor="domain-name"
                        id="assetFormLabel"
                      >
                        Business Type:
                      </label>
                    </div>
                    <div className="col-sm-9">
                      <Autocomplete
                        id="size-small-outlined"
                        size="small"
                        fullWidth
                        disableClearable
                        autoComplete="off"
                        ListboxProps={{
                          className: "custom-listbox",
                        }}
                        options={this.state.businessTypeList}
                        value={this.state.selectBusinessType}
                        getOptionLabel={(option) => option.name}
                        defaultValue={this.state.selectBusinessType}
                        onChange={(event, value) => {
                          this.handleBusinessTypeChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Business Type"
                            variant="outlined"
                            size="small"
                            className="autoComplete"
                            style={{ background: "#fff" }}
                          />
                        )}
                      />
                    </div>
                  </div>
                )}
                {this.state.businessUseCaseList.length > 0 && (
                  <div className="row mt-3 justify-align-center">
                    <div className="col-sm-3">
                      <label
                        className="col-form-label fw-bold"
                        htmlFor="domain-name"
                        id="assetFormLabel"
                      >
                        Use Case:
                      </label>
                    </div>
                    <div className="col-sm-9">
                      <Autocomplete
                        id="size-small-outlined"
                        size="small"
                        fullWidth
                        disableClearable
                        autoComplete="off"
                        ListboxProps={{
                          className: "custom-listbox",
                        }}
                        options={this.state.businessUseCaseList}
                        value={this.state.selectBusinessUsecase}
                        getOptionLabel={(option) => option.name}
                        defaultValue={this.state.selectBusinessUsecase}
                        onChange={(event, value) => {
                          this.handleBusinessUsecaseChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <div ref={params.InputProps.ref}>
                            <textarea
                              {...params.inputProps}
                              rows={2}
                              className="autoComplete"
                              style={{
                                width: "100%",
                                textTransform: "capitalize",
                                borderRadius: "6px",
                                padding: " 6px 15px",
                                border: "1px solid #a6adb4",
                              }}
                              placeholder="Use Case"
                            />
                          </div>
                        )}
                      />
                    </div>
                  </div>
                )}
              </div>
            </DialogContent>
            <DialogActions>
              <div class="col-md-12 text-center m-2">
                <Button
                  type="submit"
                  style={{
                    padding: "3px 10px",
                    background: "#37517e",
                    color: "#fff",
                    fontSize: "14px",
                    textTransform: "capitalize",
                  }}
                >
                  Move
                </Button>
              </div>
            </DialogActions>
          </ValidatorForm>
        </Dialog>
      </>
    );
  }
  handleBusinessDomainChange(selectedDomain) {
    this.getBusinessTypeList(selectedDomain);
    this.setState({
      selectBusinessDomain: selectedDomain,
      businessTypeList: [],
      businessUseCaseList: [],
      selectBusinessType: null,
      selectBusinessUsecase: null,
    });
  }
  handleBusinessTypeChange(selectedType) {
    this.getBusinessUsecaseList(selectedType);
    this.setState({
      selectBusinessType: selectedType,
      selectBusinessUsecase: null,
    });
  }
  handleBusinessUsecaseChange(selectedUsecase) {
    this.setState({
      selectBusinessUsecase: selectedUsecase,
    });
  }

  getBusinessDomainList() {
    const postObject = {
      header: this.header,
    };
    AdminFetchServerData.callPostService(ApDomainList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let businessDomainList = output.data.businessDomainList;
          this.setState({
            businessDomainList: businessDomainList,
          });
        }
      }
    );
  }

  getBusinessTypeList = (businessDomain) => {
    const postObject = {
      header: this.header,
      businessDomain: {
        id: businessDomain.id,
      },
    };
    AdminFetchServerData.callPostService(
      ApBusinessTypeList_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let businessTypeList = output.data.businessTypeList;
        this.setState({
          businessTypeList: businessTypeList,
        });
      }
    });
  };

  getBusinessUsecaseList(businessType) {
    const postObject = {
      businessType: {
        id: businessType.id,
      },
    };

    AdminFetchServerData.callPostService(ApUseCaseList_Url, postObject).then(
      (output) => {
        if (output && output.data) {
          let businessUseCaseList = output.data.businessUseCaseList || [];
          this.setState({
            businessUseCaseList: businessUseCaseList,
          });
        }
      }
    );
  }
  handlePlanCancel() {
    this.getPlanListForUseCase(this.state.businessUseCase);
  }

  getAccountListForPlan(planId, planName) {
    const postObject = {
      header: this.header,
      planId: planId,
    };

    AdminFetchServerData.callPostService(
      "/apAccountms/getListForPlan",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let planAccountList = output.data.accountList;
        let isPaging = false;
        if (planAccountList.length > this.state.pageSize) {
          isPaging = true;
        }

        for (let i = 0; i < planAccountList.length; i++) {
          planAccountList[i].subscriptionStartdate = Utils.getUtcToLocal(
            planAccountList[i].subscriptionStartdate
          );
          planAccountList[i].subscriptionEnddate = Utils.getUtcToLocal(
            planAccountList[i].subscriptionEnddate
          );
        }

        this.setState({
          openAccountPlan: true,
          isPaging: isPaging,
          planAccountList: planAccountList,
          planName: planName,
        });
      }
    });
  }

  handleAccountPlanClose() {
    this.setState({ openAccountPlan: false });
  }

  render() {
    this.previewPlansDialogueRef = React.createRef();
    this.planAccountDialogueRef = React.createRef();
    this.planRefList = [];
    for (
      let i = 0;
      this.state.planList && i < this.state.planList.length;
      i++
    ) {
      this.planRefList[i] = React.createRef();
    }

    if (this.state.action === "edit") {
      return this.editBusinessUseCase();
    } else if (this.state.action === "view") {
      return this.viewBusinessDetails();
    }
  }

  editBusinessUseCase() {
    return (
      <>
        <div className="row">
          <AdminMenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            history={this.props.history}
            name={this.title}
            pageId="viewPage"
            businessDomain={this.state.businessDomain}
            businessType={this.state.businessType}
            businessUseCase={this.state.businessUseCase}
          />
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.updateBusinessUseCaseNameToBackend.bind(this)}
          >
            <div className="row" style={{ marginTop: "1em" }}>
              <div className="col-md-12">
                <div className="card" id="organizationFormCard">
                  <div className="card-body">
                    <div className="col-md-6">
                      <div className="row mt-1">
                        <label
                          className="col-sm-3 col-form-label"
                          htmlFor="collapsible-firstname"
                        >
                          Domain Name:
                        </label>
                        <div className="col-sm-9 align-self-center" id="assetFormLabel">
                          <span>{this.state.businessDomain?.name}</span>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <label
                          className="col-sm-3 col-form-label"
                          htmlFor="collapsible-firstname"
                        >
                          Business Type:
                        </label>
                        <div className="col-sm-9 align-self-center" id="assetFormLabel">
                          {this.state.businessType?.name}
                        </div>
                      </div>
                      <div className="row mt-2">
                        <label
                          className="col-sm-3 col-form-label"
                          htmlFor="collapsible-firstname"
                        >
                          Use Case:
                        </label>
                        <div className="col-sm-9 align-self-center" id="assetFormLabel">
                          <textarea
                            rows={4}
                            required
                            title=""
                            type="text"
                            autoComplete="off"
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                            placeholder="Business Name"
                            value={this.state.useCaseName}
                            onChange={this.handleUseCaseEdit.bind(this)}
                            validators={["required"]}
                            errormessages={["This field is required"]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex align-items-center justify-content-between">
              <div className="col-sm-12 mt-3 text-center">
                <SaveButton id="saveButton" type="submit">
                  {" "}
                  Save{" "}
                </SaveButton>
                &nbsp;&nbsp;
                <CancelIconButton onClick={(e) => this.editCancel()} />
              </div>
            </div>
          </ValidatorForm >
        </div >
      </>
    );
  }
  viewBusinessDetails() {
    if (this.state.render === false) {
      return <div />;
    }
    let plans = [];
    let yearPlans = [];
    let oneTimePlans = [];
    let customOnetimePlans = [];
    let customMonthlyPlans = [];
    let customYearlyPlans = [];
    let legacyOnetimePlans = [];
    let legacyMonthlyPlans = [];
    let legacyYearlyPlans = [];
    let dailyPlans = [];
    const getTargetArray = (type) => {
      switch (type) {
        case SUBSCRIPTION_TYPES.payMonthly:
          return plans;
        case SUBSCRIPTION_TYPES.payYearly:
          return yearPlans;
        case SUBSCRIPTION_TYPES.payOnetime:
          return oneTimePlans;
        case SUBSCRIPTION_TYPES.customOnetime:
          return customOnetimePlans;
        case SUBSCRIPTION_TYPES.customMonthly:
          return customMonthlyPlans;
        case SUBSCRIPTION_TYPES.customYearly:
          return customYearlyPlans;
        case SUBSCRIPTION_TYPES.legacyOnetime:
          return legacyOnetimePlans;
        case SUBSCRIPTION_TYPES.legacyMonthly:
          return legacyMonthlyPlans;
        case SUBSCRIPTION_TYPES.legacyYearly:
          return legacyYearlyPlans;
        default:
          return dailyPlans;
      }
    };

    this.state.planList.forEach((plan, index) => {
      if (plan.operation !== "delete") {
        const type = plan.planType?.type ?? SUBSCRIPTION_TYPES.payMonthly;
        const targetArray = getTargetArray(type);

        const planCard = (
          <Col
            md={4}
            key={index}
            style={{
              marginTop: "1em",
              opacity: plan.isActive === false ? 0.5 : 1,
              backgroundColor: plan.isActive === false ? "#f5f5f5" : "inherit",
            }}
          >
            <Plan
              ref={this.planRefList[index]}
              data={plan}
              srno={index}
              action={plan.action ?? "view"}
              businessDomain={this.state.businessDomain}
              businessUseCase={this.state.businessUseCase}
              businessType={this.state.businessType}
              onPlanDelete={this.deletePlan.bind(this)}
              onDelete={this.planRemove.bind(this)}
              onPlanUpdate={this.updatePlanInBackend.bind(this)}
              addPlan={this.addPlanInBackend.bind(this)}
              addDuplicatePlan={this.addDuplicatePlan.bind(this)}
              onMovePlan={this.handleMovePlanDetailsOpen.bind(this)}
              onPlanCancel={this.handlePlanCancel.bind(this)}
              onPlanAccount={this.getAccountListForPlan.bind(this)}
            />
          </Col>
        );
        if (plan?.status?.status === "InActive") {
          targetArray.push(planCard);
        } else {
          targetArray.unshift(planCard);
        }
      }
    });

    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.title}
          domainObject={this.state.useCaseName}
          // pageId="viewPage"
          pageId="UseCase"
          businessDomain={this.state.businessDomain}
          businessType={this.state.businessType}
          businessUseCase={this.state.businessUseCase}
          backCallback={this.viewCancel.bind(this)}
          editCallback={this.editUseCaseDetails.bind(this)}
          deleteCallback={this.deleteUseCaseDetails.bind(this)}
          getDeletePermission={true}
          getUpdatePermission={true}
        />
        <PreviewPlans
          ref={this.previewPlansDialogueRef}
          style={{ float: "right" }}
        />
        <div className="row" style={{ padding: "1em", marginTop: "-12px" }}>
          <div className="card" id="organizationFormCard">
            <div className="card-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <label
                        className="col-form-label fw-bold"
                        htmlFor="domain-name"
                        id="assetFormLabel"
                      >
                        Domain Name:
                      </label>
                    </div>
                    <div className="col-sm-8">
                      <span>{this.state.businessDomain?.name}</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <label
                        className="col-form-label fw-bold"
                        htmlFor="business-type"
                        id="assetFormLabel"
                      >
                        Business Type:
                      </label>
                    </div>
                    <div className="col-sm-8">
                      <span>{this.state.businessType?.name}</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 align-self-center">
                  <Button
                    type="submit"
                    id="ptsSolidButton"
                    variant="contained"
                    style={{ width: "145px" }}
                    onClick={(e) => this.toPreviewPlansDetails()}
                  >
                    Plan Preview{" "}
                    <i class="fa fa-eye ms-2" aria-hidden="true"></i>
                  </Button>
                </div>
              </div>
              <div className="row pt-3">
                <div className="col-md-8">
                  <div className="row align-items-center">
                    <div className="col-sm-2">
                      <label
                        className="col-form-label fw-bold"
                        htmlFor="use-case"
                        id="assetFormLabel"
                      >
                        Use Case:
                      </label>
                    </div>
                    <div className="col-sm-10">
                      {this.state.businessUseCase?.name}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ maxWidth: "100%" }}>
          <div className="tab-list">
            <div
              className="content-header"
              style={{
                textAlign: "left",
                padding: "2em 0em 0em 0em",
              }}
            >
              <h3 className="m-0"> Plan options:</h3>
            </div>
            <div className="row mt-4">
              <Tabs
                defaultIndex={this.state.selectedTab}
                onSelect={(k) => this.setKey(k)}
              >
                <TabList
                  style={{
                    listStyle: "none",
                    margin: "0",
                  }}
                  className="text-start d-flex justify-content-start settingTabList ps-0"
                >
                  {this.state.tabPlanList.length > 0 &&
                    this.state.tabPlanList.map(
                      (d, index) =>
                        d !== null && (
                          <>
                            <Tab
                              className="tabSubscription hoverTab"
                              key={index}
                            >
                              {d.description}
                            </Tab>
                          </>
                        )
                    )}
                </TabList>
                {this.state.tabPlanList.length > 0 &&
                  this.state.tabPlanList.map(
                    (d, index) =>
                      d !== null && (
                        <TabPanel>
                          <div className="row">
                            <div
                              className="col-md-12 mb-0"
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginBottom: "1em",
                                float: "right",
                              }}
                            >
                              <span style={{ width: "120px" }}>
                                <PtsButton
                                  btnName="Add Plan"
                                  type="submit"
                                  onClick={this.addPlanData.bind(this, d)}
                                />
                              </span>
                            </div>
                          </div>
                          {d.type === SUBSCRIPTION_TYPES.payMonthly && (
                            <div className="row d-flex align-item-stretch ">
                              {plans}
                            </div>
                          )}
                          {d.type === SUBSCRIPTION_TYPES.payYearly && (
                            <div className="row d-flex align-item-stretch">
                              {yearPlans}
                            </div>
                          )}
                          {d.type === SUBSCRIPTION_TYPES.payOnetime && (
                            <div className="row d-flex align-item-stretch">
                              {oneTimePlans}
                            </div>
                          )}
                          {d.type === SUBSCRIPTION_TYPES.customOnetime && (
                            <div className="row d-flex align-item-stretch">
                              {customOnetimePlans}
                            </div>
                          )}
                          {d.type === SUBSCRIPTION_TYPES.customYearly && (
                            <div className="row d-flex align-item-stretch">
                              {customYearlyPlans}
                            </div>
                          )}
                          {d.type === SUBSCRIPTION_TYPES.customMonthly && (
                            <div className="row d-flex align-item-stretch">
                              {customMonthlyPlans}
                            </div>
                          )}
                          {d.type === SUBSCRIPTION_TYPES.legacyOnetime && (
                            <div className="row d-flex align-item-stretch">
                              {legacyOnetimePlans}
                            </div>
                          )}
                          {d.type === SUBSCRIPTION_TYPES.legacyMonthly && (
                            <div className="row d-flex align-item-stretch">
                              {legacyMonthlyPlans}
                            </div>
                          )}
                          {d.type === SUBSCRIPTION_TYPES.legacyYearly && (
                            <div className="row d-flex align-item-stretch">
                              {legacyYearlyPlans}
                            </div>
                          )}
                          {d.type === SUBSCRIPTION_TYPES.payDaily && (
                            <div className="row d-flex align-item-stretch">
                              {dailyPlans}
                            </div>
                          )}
                        </TabPanel>
                      )
                  )}
              </Tabs>
            </div>
          </div>
        </div>
        {this.movePlanUnderUsecase()}
        <Dialog
          open={this.state.openAccountPlan}
          onClose={this.handleAccountPlanClose.bind(this)}
          maxWidth="xl"
          className="MsgQRCodeDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Account list for plan: {this.state.planName}</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleAccountPlanClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent>
            <div
              style={{
                width: "100%",
                color: "#000",
                fontSize: "small",
                padding: "0.5em",
              }}
            >
              <div style={{ maxWidth: "100%" }}>
                <MaterialTable
                  title=""
                  icons={UiUtils.getMaterialTableIcons()}
                  localization={{
                    body: {
                      emptyDataSourceMessage: <h5>There are no accounts in this plan.</h5>,
                    },
                  }}
                  columns={[
                    {
                      title: "#",
                      render: (rowData) => rowData.tableData.id + 1,
                      width: "5%",
                      align: "left",
                      cellStyle: {
                        width: "6%",
                      },
                    },
                    {
                      title: "Company Name",
                      field: "tenantName",
                      cellStyle: {
                        width: "20%",
                      },
                    },
                    {
                      title: "Type",
                      field: "subscriptionType",
                      cellStyle: {
                        width: "20%",
                      },
                    },
                    {
                      title: "Start Date",
                      field: "subscriptionStartdate",
                      cellStyle: {
                        width: "20%",
                      },
                    },
                    {
                      title: "Price",
                      render: (rowData) =>
                        `${rowData?.customerPlan?.currencySymbol}${rowData?.customerPlan?.price}`,
                      cellStyle: {
                        width: "20%",
                      },
                    },
                  ]}
                  data={this.state.planAccountList}
                  options={{
                    sorting: true,
                    search: this.state.planAccountList?.length > 10,
                    actionsColumnIndex: -1,
                    initialPage: this.state.initialPage,
                    pageSize: this.state.pageSize,
                    pageSizeOptions: [5, 10, 20, 50, 100],
                    paging: this.state.isPaging,
                    headerStyle: {
                      backgroundColor: "#37517e",
                      fontWeight: "bold",
                      color: "#ffff",
                      align: "left",
                    },
                  }}
                />
              </div>
            </div>
          </DialogContent>
        </Dialog >
      </>
    );
  }
}

export default withRouter(PlanList);
